import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import Slider from "react-slick"; // Import Slick Slider
import ProductServices from '../services/API/ProductServices';
import { BASE_URL } from '../services/Constant';
import { Link } from 'react-router-dom';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

// Import Slick styles
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css"; 

const MainSec2 = () => {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const activeProductData = async () => {
    try {
      const res = await ProductServices.all();
      if (res.status) {
        setProducts(res.data);
        console.log('data', res.data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching product data:", error);
    }
  };

  useEffect(() => {
    activeProductData();
  }, []);

  const shuffleArray = (array) => {
    return array.sort(() => Math.random() - 0.5);
  };

  const shuffledProducts = shuffleArray([...products]); // Shuffle products array

  // Slick Slider Settings
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <>
      <Container className='mt-5'>
        <h2 className='product-sec2-eplore-h2'>EXPLORE MORE PRODUCTS</h2>
      </Container>
      <div className='product-sec2-slider'>
      <Carousel
      responsive={responsive}
      
      itemClass="carousel-item-padding-40-px"
      >
          {shuffledProducts.map((product, index) => (
             <a key={index} href={`/product/${product.id}`} className='block bg-white p-4 rounded-lg shadow-md hover:shadow-xl transition transform hover:-translate-y-1 text-left mx-3'>
                                        <div className='relative h-48 w-full overflow-hidden rounded-lg'>
                                          <img
                                            src={`${BASE_URL}${product.image}`} alt={product.name}
                                            className='w-full h-full object-contain mx-auto'
                                          />
                                        </div>
                                        <h4 className='mt-4 text-lg font-semibold text-gray-800'>{product.name.split(" ").slice(0, 4).join(" ")}{product.name.split(" ").length > 4 ? "..." : ""}</h4>
                                        <span className='text-gray-600 text-md font-medium'>${product.price}</span>
                                      </a>
          ))}
        </Carousel>
      </div>
    </>
  );
};

export default MainSec2;
